export default "__VITE_ASSET__D3iXp2T0__"